module.exports = __webpack_public_path__ + "static/media/close.62d81985.svg";